import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalHeader,
    ModalBody,
    FormControl,
    FormLabel,
    ModalFooter,
    Button,
    useDisclosure,
    Input,
} from "@chakra-ui/react";
import { useEffect, useContext, useState } from "react";
import { RedemptionStatementModal } from "./RedemptionStatementModal";
import moment from "moment";
import { LoanContext } from "providers/loan";

interface RedemptionStatementSearchModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export function RedemptionStatementSearchModal({
    isOpen,
    onClose,
}: RedemptionStatementSearchModalProps) {
    const [lastStatementDate, setLastStatementDate] = useState<string>(
        moment().format("YYYY-MM-DD")
    );

    const {
        isOpen: isRedemptionStatementOpen,
        onOpen: openRedemptionStatement,
        onClose: closeRedemptionStatement,
    } = useDisclosure();

    const handleSubmit = (): void => {
        openRedemptionStatement();
    };

    const handleRedemptionStatementClose = (): void => {
        closeRedemptionStatement();
        onClose();
    };

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size="xl">
                <ModalOverlay />
                <ModalContent
                    as="form"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                    noValidate
                >
                    <ModalCloseButton />
                    <ModalHeader>
                        Redemption Statement
                        <Text fontSize="16px" fontWeight="300">
                            View and download statements
                        </Text>
                    </ModalHeader>
                    <ModalBody>
                        <FormControl>
                            <FormLabel>Redemption Date</FormLabel>
                            <Input
                                type="date"
                                variant="outline"
                                value={lastStatementDate}
                                onChange={(e) =>
                                    setLastStatementDate(e.target.value)
                                }
                            />
                        </FormControl>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button onClick={onClose} variant="outline">
                            Close
                        </Button>
                        <Button type="submit">View Statement</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            {isRedemptionStatementOpen && (
                <RedemptionStatementModal
                    onClose={handleRedemptionStatementClose}
                    lastStatementDate={lastStatementDate}
                    isOpen={isRedemptionStatementOpen}
                />
            )}
        </>
    );
}
